<template>
  <div>
    <div class="card p-4 shadow-sm">
      <h3 class="mb-3">Complementos de platillos</h3>
       <!-- Campo de búsqueda -->
      <div class="mb-3">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar producto por nombre"
          v-model="busqueda"
          @input="buscarProducto"
        />
      </div>

      <!-- Botón agregar -->
      <div class="d-flex justify-content-end mb-3">
        <button class="btn btn-success" @click="mostrarFormulario = true">
          + Agregar Opción
        </button>
      </div>

      <!-- Toast -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Formulario crear -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nueva Opción</h5>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Nombre</label>
            <input v-model="nuevaOpcion.Nombre" type="text" class="form-control" />
          </div>
        </div>

        <!-- Recetas -->
        <h6 class="mt-3">Recetas</h6>
        <div
          v-for="(rec, index) in nuevaOpcion.recetas"
          :key="index"
          class="row g-3 mb-2"
        >
          <div class="col-md-5">
            <label class="form-label">Producto</label>
            <SearchableSelect
              v-model="rec.IdProductoRestaurante"
              :items="productos"
              item-value="IdProductoRestaurante"
              item-label="NombreProducto"
              placeholder="Buscar producto..."
              :show-selected="false"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label">Cantidad</label>
            <input v-model.number="rec.Cantidad" type="number" min="1" class="form-control" />
          </div>
          <div class="col-md-1 d-flex align-items-end">
            <button class="btn btn-danger btn-sm" @click="eliminarReceta(index)">X</button>
          </div>
        </div>
        <button class="btn btn-secondary btn-sm mt-2" @click="agregarReceta">
          + Agregar Receta
        </button>

        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarOpcion">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombre</th>
              <th>Recetas</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="opciones.length === 0">
              <td colspan="3">No hay opciones registradas.</td>
            </tr>
            <tr v-for="opc in opciones" :key="opc.IdOpcion">
              <td>{{ opc.Nombre }}</td>
              <td>
                <ul class="list-unstyled">
                  <li v-for="rec in opc.recetas_opciones" :key="rec.IdRecetaOpcion">
                    {{ rec.producto?.NombreProducto || "Producto eliminado" }}
                    - Cantidad: {{ rec.Cantidad }}
                  </li>
                </ul>
              </td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(opc)">
                  Editar
                </button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(opc)">
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <!-- Modal Editar f  -->
      <div v-if="mostrarModal" class="modal-backdrop" @click.self="cerrarModal">
        <div class="modal-content overflow-scroll max-h-[500px]" @click.stop>
          <div class="modal-header">
            <h5 class="modal-title">Editar Opción</h5>
            <button type="button" class="btn-close" @click="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Nombre</label>
              <input v-model="opcionEditar.Nombre" type="text" class="form-control" />
            </div>

            <h6>Recetas</h6>
            <div
              v-for="(rec, index) in opcionEditar.recetas_opciones"
              :key="index"
              class="row g-3 mb-2"
            >
              <div class="col-md-5">
                <SearchableSelect
                  v-model="rec.IdProductoRestaurante"
                  :items="productos"
                  item-value="IdProductoRestaurante"
                  item-label="NombreProducto"
                  placeholder="Buscar producto..."
                  :show-selected="false"
                />
              </div>
              <div class="col-md-3">
                <input v-model.number="rec.Cantidad" type="number" min="1" class="form-control" />
              </div>
              <div class="col-md-1 d-flex align-items-end">
                <button class="btn btn-danger btn-sm" @click="opcionEditar.recetas_opciones.splice(index, 1)">
                  X
                </button>
              </div>
            </div>
            <button class="btn btn-secondary btn-sm mt-2" @click="opcionEditar.recetas_opciones.push({ IdProductoRestaurante: '', Cantidad: 1 })">
              + Agregar Receta
            </button>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary me-2" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarOpcion">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop" @click.self="cerrarModalEliminar">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar la opción <strong>{{ opcionEliminar?.Nombre }}</strong>?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary me-2" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import SearchableSelect from "@/components/shared/SearchableSelect.vue";

export default {
  components: {
    SearchableSelect
  },
  name: "OpcionesComida",
  data() {
    return {
      opciones: [],
      productos: [],
      copiaLista: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      nuevaOpcion: {
        Nombre: "",
        recetas: [{ IdProductoRestaurante: "", Cantidad: 1 }]
      },
      opcionEditar: null,
      opcionEliminar: null,
      mostrarToast: false,
       busqueda: "",
      alerta: { mensaje: "", tipo: "success" }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerOpciones() {
      const { data } = await axios.get(`${API_URL}/opciones-comida`);
      this.opciones = data.data || data;
      this.copiaLista = [...this.opciones];
    },
    async obtenerProductos() {
      const { data } = await axios.get(`${API_URL}/inventario-general-restaurante`);
      this.productos = data;
    },
    agregarReceta() {
      this.nuevaOpcion.recetas.push({ IdProductoRestaurante: "", Cantidad: 1 });
    },
    eliminarReceta(index) {
      this.nuevaOpcion.recetas.splice(index, 1);
    },
    async guardarOpcion() {
      try {
        const { data } = await axios.post(`${API_URL}/opciones-comida`, this.nuevaOpcion);
        this.mostrarAlerta(data.message || "Opción creada con éxito");
        this.nuevaOpcion = { Nombre: "", recetas: [{ IdProductoRestaurante: "", Cantidad: 1 }] };
        this.mostrarFormulario = false;
        this.obtenerOpciones();
      } catch (error) {
        this.mostrarAlerta(error.response?.data?.message || "Error al guardar", "danger");
      }
    },
    abrirModal(opc) {
      this.opcionEditar = JSON.parse(JSON.stringify(opc));
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.opcionEditar = null;
      this.mostrarModal = false;
    },
    async actualizarOpcion() {
  try {
    // Mapear recetas_opciones a recetas
    const payload = {
      Nombre: this.opcionEditar.Nombre,
      recetas: this.opcionEditar.recetas_opciones.map(r => ({
        IdProductoRestaurante: r.IdProductoRestaurante,
        Cantidad: r.Cantidad
      }))
    };

    const { data } = await axios.put(
      `${API_URL}/opciones-comida/${this.opcionEditar.IdOpcion}`,
      payload
    );

    this.mostrarAlerta(data.message || "Opción actualizada");
    this.cerrarModal();
    this.obtenerOpciones();
  } catch (error) {
    this.mostrarAlerta(error.response?.data?.message || "Error al actualizar", "danger");
  }
}
,
    abrirModalEliminar(opc) {
      this.opcionEliminar = { ...opc };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mostrarModalEliminar = false;
      this.opcionEliminar = null;
    },
       buscarProducto() {
    const q = (this.busqueda || "").trim().toLowerCase();

    if (!q) {
      this.opciones = [...this.copiaLista];
      return;
    }

    this.opciones = this.copiaLista.filter(opc =>
      (opc.Nombre || "").toLowerCase().includes(q)
    );
  },
    async confirmarEliminar() {
      try {
        const { data } = await axios.delete(`${API_URL}/opciones-comida/${this.opcionEliminar.IdOpcion}`);
        this.mostrarAlerta(data.message || "Opción eliminada");
        this.obtenerOpciones();
      } catch (error) {
        this.mostrarAlerta(error.response?.data?.message || "Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevaOpcion = { Nombre: "", recetas: [{ IdProductoRestaurante: "", Cantidad: 1 }] };
    }
  },
  mounted() {
    this.obtenerOpciones();
    this.obtenerProductos();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 5001;
}
</style>
